import { formatDate } from "../../../siteWidgets/siteWidgetUtils"
interface DateToHebrewDayProps {
    date: string
}


export class DateToHebrewDay extends React.Component<DateToHebrewDayProps, {}> {
    public static siteScriptName = "DateToHebrewDay";

    private static hebrewDays = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"];

    private convertDateToDay = (date: string): string => {
        if(!date) return "";
        const dateObj = new Date(date);
        const dayIndex = dateObj.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        return dayIndex === 6 ? DateToHebrewDay.hebrewDays[dayIndex - 1] : DateToHebrewDay.hebrewDays[dayIndex];
    }
    private formatPaperDate = (date: string): string => {
          if(!date) return "";
        const dateObj = new Date(date);
        formatDate(dateObj, "DD.MM.YYYY");
        return formatDate(dateObj, "DD.MM.YYYY");
    }

    public render() {

        const { date } = this.props;
        return (
            <>
                <span className="mainLogoDay">{this.convertDateToDay(date)} </span>
                <span className="mainLogoDate"> {this.formatPaperDate(date)}</span>
            </>
        )
    }
}